export default __webpack_public_path__ + "static/media/tyre.5dc125fd.png";